import { Card, Col, Row, Statistic, Tooltip, Typography } from 'antd'
import {
  SpendMetrics,
  formatPct,
  formatTokens,
  formatUsd,
  formatUsdPrecise,
} from './spendModel'

const { Text } = Typography

type Props = {
  totals: SpendMetrics
  loading: boolean
}

const SpendSummaryCards = ({ totals, loading }: Props) => (
  <Row gutter={[16, 16]}>
    <Col xs={24} sm={12} xl={6}>
      <Card size="small">
        <Statistic
          title="Total spend"
          value={formatUsd(totals.cost_usd)}
          loading={loading}
        />
        <Text type="secondary">
          {formatTokens(totals.turns)} turns over {formatTokens(totals.sessions)}{' '}
          sessions
        </Text>
      </Card>
    </Col>

    <Col xs={24} sm={12} xl={6}>
      <Card size="small">
        <Tooltip title="What the same tokens would have cost with no prompt caching, priced at current rates.">
          <Statistic
            title="Saved by caching"
            value={formatUsd(totals.savings_usd)}
            loading={loading}
            valueStyle={{ color: '#3f8600' }}
          />
        </Tooltip>
        <Text type="secondary">
          {formatPct(totals.savings_pct)} off {formatUsd(totals.uncached_equivalent_usd)}
        </Text>
      </Card>
    </Col>

    <Col xs={24} sm={12} xl={6}>
      <Card size="small">
        <Statistic
          title="Cost per session"
          value={formatUsdPrecise(totals.avg_cost_per_session)}
          loading={loading}
        />
        <Text type="secondary">
          {formatUsdPrecise(totals.avg_cost_per_turn)} per turn
        </Text>
      </Card>
    </Col>

    <Col xs={24} sm={12} xl={6}>
      <Card size="small">
        <Statistic
          title="Tokens read from cache"
          value={formatTokens(totals.cache_read_tokens)}
          loading={loading}
        />
        {/*
          The four classes are disjoint and priced differently: fresh input at
          the base rate, cache writes at 1.25x, cache reads at 0.10x. Showing
          them together is what makes a jump in spend explainable.
        */}
        <Text type="secondary">
          {formatTokens(totals.cache_write_tokens)} written ·{' '}
          {formatTokens(totals.input_tokens)} fresh ·{' '}
          {formatTokens(totals.output_tokens)} out
        </Text>
      </Card>
    </Col>
  </Row>
)

export default SpendSummaryCards
